enum EnterprisePlanInvoiceKind {
  NewBusiness = "new_business",
  Overage = "overage",
  Renewal = "renewal",
  Expansion = "expansion",
  Credit = "credit",
}

export default EnterprisePlanInvoiceKind;
